import { type Components } from '@mui/material';

import { type HorizonTheme } from './horizon-theme';

export const muiTableRow: Components<HorizonTheme>['MuiTableRow'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&:first-of-type th': {
        backgroundColor: theme.palette.gray100.main,
      },
    }),
  },
};
